import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SponsorshipStatusResponse} from '../Modules/education-info/models/SponsorshipStatusResponse';
import {DisabilityStatusResponse} from '../Modules/preliminary-info/modal/DisabilityStatusResponse';
import {ApplicantPaymentStatusInterface} from '../../pre-applicant/Models/necta-models/payment-status-model';
import { SharedHeadersService } from 'src/app/shared/shared-headers.service';
@Injectable({
  providedIn: 'root'
})
export class CheckStatusServiceService {
  private baseUrl = environment.application_base_url;
  private apiUrl = environment.application_base_url + 'education-info/sponsorship-status/';
  private apiUrlDisAbility = environment.application_base_url + 'preliminary/check-disability-status/';

  constructor(private http: HttpClient, public shared_headers_service: SharedHeadersService) { }

  public checkSponsorshipStatus(profileId: string, applicationYear: string, attachmentType: string): Observable<SponsorshipStatusResponse> {
     let headers =  this.shared_headers_service.default_headers()
    const params = new HttpParams()
      .set('profileId', profileId)
      .set('applicationYear', applicationYear)
      .set('attachment_type', attachmentType);
    return this.http.get<SponsorshipStatusResponse>( this.apiUrl, { params, headers: headers } );
  }
  public checkDisabilityStatus(profileId: string, applicationYear: string, attachmentType: string, disablePerson: string): Observable<DisabilityStatusResponse> {
    let headers =  this.shared_headers_service.default_headers()

    const params = new HttpParams()
      .set('profileId', profileId)
      .set('applicationYear', applicationYear)
      .set('disable_person', disablePerson)
      .set('attachment_type', attachmentType);
    return this.http.get<DisabilityStatusResponse>(this.apiUrlDisAbility, { params, headers: headers  });
  }
}
